"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertsActions = exports.alertsSliceReducer = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var alertsEntityAdapter_1 = require("./alertsEntityAdapter");
var alertsSlice = toolkit_1.createSlice({
    name: "alerts",
    initialState: alertsEntityAdapter_1.alertsAdapter.getInitialState(),
    reducers: {
        setAlerts: alertsEntityAdapter_1.alertsAdapter.setAll,
        addAlert: alertsEntityAdapter_1.alertsAdapter.addOne,
        updateAlert: alertsEntityAdapter_1.alertsAdapter.updateOne,
        removeAlert: alertsEntityAdapter_1.alertsAdapter.removeOne,
        removeAlerts: alertsEntityAdapter_1.alertsAdapter.removeMany,
    },
});
exports.alertsSliceReducer = alertsSlice.reducer;
exports.alertsActions = alertsSlice.actions;
//# sourceMappingURL=index.js.map